<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    size="large"
    style="z-index: 100;"
    id="gl-dialog">
    <el-row v-loading.body="loading" element-loading-text="Loading report options, please wait..." style="padding-bottom: 24px;">
      <el-col>
        <el-row type="flex" align="middle" justify="end" style="padding: 10px 0; border-bottom: 1px solid lightgrey;">
          <el-col>
            <el-row type="flex" align="middle" justify="start" style="font-size: 22px; padding: 12px;">
              {{ name }}
            </el-row>
          </el-col>
          <el-col>
            <el-row type="flex" align="middle" justify="end">
              <el-button plain @click="closeViewer(false)">
                Close
              </el-button>
              <el-button type="primary" @click="generateReport" :disabled="!requirementsMet">
                Run report
              </el-button>
            </el-row>
          </el-col>
        </el-row>
        <!--Required fields-->
        <el-row
          type="flex"
          align="top"
          justify="center"
          id="gl-form-small"
          v-if="endpoint && fields"
          style="padding: 12px;">
          <el-col>
            <el-row type="flex" style="margin-top: 12px;">
              <el-col :span="24">
                <el-row type="flex">
                  <el-col>
                    <el-row type="flex" class="field-section-header">
                      Required Fields
                    </el-row>
                    <!--Template selection-->
                    <el-row
                      type="flex"
                      align="middle"
                      justify="start"
                      v-if="templates && Object.keys(templates).length && Object.keys(templates).length > 1">
                      <el-col :span="12">
                        <el-row type="flex" align="middle" class="field-row">
                          <el-col :span="4">
                            <el-row type="flex" justify="end" align="middle" class="opts-col-name">
                              Template
                            </el-row>
                          </el-col>
                          <el-col :span="12" class="input-container">
                            <el-row>
                              <el-radio-group v-model="template" size="small">
                                <el-radio-button v-for="(v, k) in templates" :label="k.charAt(0).toUpperCase() + k.slice(1)" :key="k">
                                  {{ k.charAt(0).toUpperCase() + k.slice(1) }}
                                </el-radio-button>
                              </el-radio-group>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <!--Required fields of type "select"-->
                    <el-row type="flex" v-if="requiredSelectFields && requiredSelectFields.length">
                      <el-col :span="12">
                        <el-row
                          class="field-row"
                          type="flex"
                          align="middle"
                          v-for="(f, i) in requiredSelectFields" v-if="i % 2 === 0"
                          :key="`${f}${i}`">
                          <el-col :span="4">
                            <el-row type="flex" align="middle" justify="end" class="select-field-label">
                              {{ f.name }}
                            </el-row>
                          </el-col>
                          <el-col :span="12" class="input-container">
                            <el-row type="flex">
                              <el-select
                                :ref="f.fieldName"
                                :name="f.fieldName"
                                :filterable="(f.choices.length > 10)"
                                v-model="form[f.fieldName]"
                                style="width: 100%;">
                                <el-option
                                  v-for="choice in f.choices"
                                  :key="choice.display_name"
                                  :label="choice.display_name"
                                  :value="choice.value">
                                </el-option>
                              </el-select>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="12">
                        <el-row
                          class="field-row"
                          type="flex"
                          align="middle" v-for="(f, i) in requiredSelectFields" v-if="i % 2 === 1"
                          :key="`${f}${i}`">
                          <el-col :span="4">
                            <el-row type="flex" align="middle" justify="end" class="select-field-label">
                              {{ f.name }}
                            </el-row>
                          </el-col>
                          <el-col :span="12" class="input-container">
                            <el-row type="flex">
                              <el-select
                                :ref="f.fieldName"
                                :name="f.fieldName"
                                :filterable="(f.choices.length > 10)"
                                v-model="form[f.fieldName]"
                                style="width: 100%;">
                                <el-option
                                  v-for="choice in f.choices"
                                  :key="choice.display_name"
                                  :label="choice.display_name"
                                  :value="choice.value">
                                </el-option>
                              </el-select>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <!--Required text input fields-->
                    <el-row type="flex" v-if="requiredTextInputFields && requiredTextInputFields.length">
                      <el-col :span="12">
                        <el-row
                          class="field-row"
                          type="flex"
                          align="middle"
                          v-for="(f, i) in requiredTextInputFields" v-if="i % 2 === 0"
                          :key="`${f}${i}`">
                          <el-col :span="4">
                            <el-row type="flex" align="middle" justify="end" class="select-field-label">
                              {{ f.name }}
                            </el-row>
                          </el-col>
                          <el-col :span="12" class="input-container">
                            <el-row type="flex">
                              <el-input :ref="f.fieldName" :name="f.fieldName" @blur="handleBlur" v-model="form[f.fieldName]" placeholder=""></el-input>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="12">
                        <el-row
                          class="field-row"
                          type="flex"
                          align="middle"
                          v-for="(f, i) in requiredTextInputFields" v-if="i % 2 === 1"
                          :key="`${f}${i}`">
                          <el-col :span="4">
                            <el-row type="flex" align="middle" justify="end" class="select-field-label">
                              {{ f.name }}
                            </el-row>
                          </el-col>
                          <el-col :span="12" class="input-container">
                            <el-row type="flex">
                              <el-input :ref="f.fieldName" :name="f.fieldName" @blur="handleBlur" v-model="form[f.fieldName]" placeholder=""></el-input>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <!--Required fields of type "many"-->
                    <el-row type="flex" align="middle" justify="start" v-if="requiredFieldsOfTypeMany && requiredFieldsOfTypeMany.length">
                      <el-col :span="12">
                        <el-row
                          class="field-row"
                          type="flex"
                          align="middle"
                          v-for="(f, i) in requiredFieldsOfTypeMany" v-if="i % 2 === 0"
                          :key="`${f}${i}`">
                          <el-col :span="4">
                            <el-row type="flex" align="middle" justify="end" class="select-field-label">
                              {{ f.name }}
                            </el-row>
                          </el-col>
                          <el-col :span="12" class="input-container">
                            <el-row type="flex">
                              <el-select
                                :ref="f.fieldName"
                                :name="f.fieldName"
                                v-model="form[f.fieldName]"
                                multiple
                                :filterable="(f.choices.length > 10)"
                                style="width: 100%;">
                                <el-option
                                  v-for="choice in f.choices"
                                  :key="choice.display_name"
                                  :label="choice.display_name"
                                  :value="choice.value">
                                </el-option>
                              </el-select>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="12">
                        <el-row
                          class="field-row"
                          type="flex"
                          align="middle"
                          v-for="(f, i) in requiredFieldsOfTypeMany" v-if="i % 2 === 1"
                          :key="`${f}${i}`">
                          <el-col :span="4">
                            <el-row type="flex" align="middle" justify="end" class="select-field-label">
                              {{ f.name }}
                            </el-row>
                          </el-col>
                          <el-col :span="12" class="input-container">
                            <el-row type="flex">
                              <el-select
                                :ref="f.fieldName"
                                :name="f.fieldName"
                                v-model="form[f.fieldName]"
                                multiple
                                :filterable="(f.choices.length > 10)"
                                style="width: 100%;">
                                <el-option
                                  v-for="choice in f.choices"
                                  :key="choice.display_name"
                                  :label="choice.display_name"
                                  :value="choice.value">
                                </el-option>
                              </el-select>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <!--Required 'account_in' field of type 'many'-->
                    <el-row type="flex" align="middle" justify="start" v-if="requiredAccountFieldOfTypeMany && requiredAccountFieldOfTypeMany.length">
                      <el-col :span="24">
                        <el-row
                          class="field-row"
                          type="flex"
                          align="middle"
                          v-for="(f, i) in requiredAccountFieldOfTypeMany"
                          :key="`${f}${i}`">
                          <el-col :span="24">
                            <el-row type="flex" align="middle" justify="start" style="margin-bottom: 12px;">
                              {{ f.name }}
                            </el-row>
                            <el-row>
                              <el-transfer
                                :titles="['Available', 'To Apply']"
                                class="transfer-filters"
                                filterable
                                @change="handleChange"
                                :filter-method="filterMethod"
                                :filter-placeholder="f.name"
                                :props="{ key: 'value', label: 'label' }"
                                :ref="f.fieldName"
                                v-model="form[f.fieldName]"
                                :data="transferElData(f.choices)">
                              </el-transfer>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!--Optional fields-->
        <el-row v-if="optionalFields && optionalFields.length" style="padding: 12px;" v-loading.body="trnLoading" element-loading-text="Loading transactions, please wait...">
          <el-col :span="24">
            <el-row type="flex">
              <el-col>
                <el-row type="flex" class="field-section-header">
                  Optional Fields
                </el-row>
                <!--Optional select fields that aren't of type "many"-->
                <el-row type="flex" align="middle" justify="start" v-if="optionalSelectFields && optionalSelectFields.length">
                  <el-col :span="12">
                    <el-row
                      class="field-row"
                      type="flex"
                      align="middle"
                      v-for="(f, i) in optionalSelectFields" v-if="i % 2 === 0"
                      :key="`${f}${i}`">
                      <el-col :span="4">
                        <el-row type="flex" align="middle" justify="end" class="select-field-label">
                          {{ f.name }}
                        </el-row>
                      </el-col>
                      <el-col :span="12" class="input-container">
                        <el-row type="flex">
                          <el-select
                            :ref="f.fieldName"
                            :name="f.fieldName"
                            :filterable="(f.choices.length > 10)"
                            v-model="form[f.fieldName]"
                            style="width: 100%;">
                            <el-option
                              v-for="choice in f.choices"
                              :key="choice.display_name"
                              :label="choice.display_name"
                              :value="choice.value">
                            </el-option>
                          </el-select>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="12">
                    <el-row
                      class="field-row"
                      type="flex"
                      align="middle"
                      v-for="(f, i) in optionalSelectFields" v-if="i % 2 === 1"
                      :key="`${f}${i}`">
                      <el-col :span="4">
                        <el-row type="flex" align="middle" justify="end" class="select-field-label">
                          {{ f.name }}
                        </el-row>
                      </el-col>
                      <el-col :span="12" class="input-container">
                        <el-row type="flex">
                          <el-select
                            :ref="f.fieldName"
                            :name="f.fieldName"
                            :filterable="(f.choices.length > 10)"
                            v-model="form[f.fieldName]"
                            style="width: 100%;">
                            <el-option
                              v-for="choice in f.choices"
                              :key="choice.display_name"
                              :label="choice.display_name"
                              :value="choice.value">
                            </el-option>
                          </el-select>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <!--Optional text input fields that aren't of type "many"-->
                <el-row type="flex" align="middle" justify="start" v-if="optionalTextInputFields && optionalTextInputFields.length">
                  <el-col :span="12">
                    <el-row
                      class="field-row"
                      type="flex"
                      align="middle"
                      v-for="(f, i) in optionalTextInputFields" v-if="i % 2 === 0"
                      :key="`${f}${i}`">
                      <el-col :span="4">
                        <el-row type="flex" align="middle" justify="end" class="select-field-label">
                          {{ f.name }}
                        </el-row>
                      </el-col>
                      <el-col :span="12" class="input-container">
                        <el-row type="flex">
                          <el-input
                            :ref="f.fieldName"
                            :name="f.fieldName"
                            @blur="handleBlur"
                            v-model="form[f.fieldName]"
                            placeholder="">
                          </el-input>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="12">
                    <el-row
                      class="field-row"
                      type="flex"
                      align="middle"
                      v-for="(f, i) in optionalTextInputFields" v-if="i % 2 === 1"
                      :key="`${f}${i}`">
                      <el-col :span="4">
                        <el-row type="flex" align="middle" justify="end" class="select-field-label">
                          {{ f.name }}
                        </el-row>
                      </el-col>
                      <el-col :span="12" class="input-container">
                        <el-row type="flex">
                          <el-input
                            :ref="f.fieldName"
                            :name="f.fieldName"
                            @blur="handleBlur"
                            v-model="form[f.fieldName]"
                            placeholder="">
                          </el-input>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <!--Optional fields of type many-->
                <el-row style="margin-top: 6px;" v-if="optionalFieldsOfTypeMany && optionalFieldsOfTypeMany.length">
                  <el-col :span="24">
                    <el-row style="margin-top: 12px">
                      <el-radio-group v-model="visibleOptionalField" size="small">
                        <el-radio-button v-for="(field, i) in optionalFieldsOfTypeMany" :label="field.name" :key="i">
                          {{ field.name }}
                        </el-radio-button>
                      </el-radio-group>
                    </el-row>
                    <el-row type="flex" style="margin-top: 6px">
                      <el-transfer
                        :titles="['Available', 'To Apply']"
                        class="transfer-filters"
                        filterable
                        @change="handleChange"
                        :filter-method="filterMethod"
                        :filter-placeholder="visibleOptionalField"
                        :props="{ key: 'value', label: 'label' }"
                        :ref="visibleOptionalFieldName"
                        v-model="form[visibleOptionalFieldName]"
                        :data="transferElData(getOptionalFieldChoices())">
                      </el-transfer>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { mapGetters } from 'vuex'
  import { notify } from '@/utils/helpers/Notify'
  import { reportMixins } from '@/Mixins/Reports'
  import { buildInitPromiseIterable } from '@/utils/helpers/BuildPromiseIterable'
  import { capitalizeFirstLetter } from '@/utils/helpers/StringOperations'
  import { formatDateFields } from '@/utils/helpers/FormatDate'

  export default {
    name: 'Report',
    mixins: [ reportMixins ],
    data () {
      return {
        form: {},
        template: null,
        requirementsMet: false,
        availableEndpoints: [
          'audit/transaction',
          'audit/account',
          'ledger/detail',
          'ledger/summary',
          'posting/transaction',
          'posting/account',
          'receivables/detail',
          'receivables/summary'
        ],
        endpoint: null,
        visibleOptionalField: null,
        currencyWarning: null,
        currencyWarningShown: false,
        trnLoading: false,
        loading: false,
        loaded: false
      }
    },
    methods: {
      handleBlur (e) {
        if (e && (e.target.name.includes('date') || e.target.name.includes('time'))) {
          this.formatDateFields(e.target.name)
        }
      },
      /**
       * Formats dates to YYYY-MM-DD format
       */
      formatDateFields (fieldName) {
        formatDateFields(this, fieldName, true)
      },
      /**
       * Capitalizes the first letter in a string
       */
      capitalizeFirst (string) {
        return capitalizeFirstLetter(string)
      },
      /**
       * Returns the length of the selection object
       */
      getLen () {
        return Object.keys(this.selectFields()).length
      },
      /**
       * Displays a warning informing the user that banks with multiple currencies have been selected and
       * sets a flag that determines whether this notification has already been shown.
       */
      showCurrencyWarning () {
        const text = 'You have selected banks with multiple currencies. If you wish to normalize amounts in this way, you should specify a Base Currency. Otherwise USD is assumed.'
        this.currencyWarning = this.$confirm(text, 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
        this.currencyWarningShown = true
      },
      /**
       * Returns the number of distinct currencies from the set of selected banks
       */
      checkBankCurrencies () {
        let banks = []
        this.form.transaction__batch__bank__in.forEach(bankId => banks.push(this.getBankById(bankId)))
        let currencies = [...new Set(banks.map(v => v.currency))]
        return (currencies.length > 1)
      },
      /**
       * Generates the report once fields have been filled and are valid
       */
      generateReport () {
        let fieldName = this.visibleOptionalFieldName
        if (!this.requirementsMet) return
        if (this.endpoint.includes('account')) {
          this.updateSelectedTransactions()
        }
        if (this.form.payroll && this.form.payroll.length) {
          this.form.journalentry = this.form.payroll
          this.form.payroll = undefined
        }

        if (this.endpoint === 'audit/transaction' || this.endpoint === 'posting/transaction') {
          if (!this.form[fieldName]) {
            let group = []
            let missing = {}
            let choices = this.getOptionalFieldChoices().map(choice => choice.value)
            switch (fieldName) {
              case 'accountspayable':
                for (let f in choices) {
                  let res = this.getApById(choices[f])
                  if (!Object.keys(res).length) res = { id: choices[f], t: 'aps', missing: true }
                  group.push(res)
                }
                break
              case 'journalentry':
                for (let f in choices) {
                  let res = this.getJeById(choices[f])
                  if (!Object.keys(res).length) res = { id: choices[f], t: 'jes', missing: true }
                  group.push(res)
                }
                break
              case 'payroll':
                for (let f in choices) {
                  let res = this.getJeById(choices[f])
                  if (!Object.keys(res).length) res = { id: choices[f], t: 'jes', missing: true }
                  group.push(res)
                }
                break
              case 'pettycash':
                for (let f in choices) {
                  let res = this.getPcById(choices[f])
                  if (!Object.keys(res).length) res = { id: choices[f], t: 'pcs', missing: true }
                  group.push(res)
                }
                break
              case 'accountsreceivable':
                for (let f in choices) {
                  let res = this.getArById(choices[f])
                  if (!Object.keys(res).length) res = { id: choices[f], t: 'ars', missing: true }
                  group.push(res)
                }
                break
            }

            for (let i = 0; i < group.length; i++) {    // Figure out which transactions are missing
              if (group[i].hasOwnProperty('missing')) {
                let { t } = group[i]
                if (missing.hasOwnProperty(t) && Array.isArray(missing[t])) {
                  missing[t].push(group[i].id)
                } else {
                  missing[t] = [group[i].id]
                }
              }
            }

            if (Object.keys(missing).length) {          // Fetch the missing transactions, if any
              let promises = buildInitPromiseIterable(this.$store, missing)
              Promise.all(promises)
                .then(r => {
                  group = group.map(v => {              // TODO: refactor O(n^2) ugliness
                    if (!v.hasOwnProperty('t')) return v
                    let m = r.find(x => {
                      const trxs = x.entities && x.entities[v.t] ? x.entities[v.t] : null
                      if (v.id && trxs && trxs[v.id]) {
                        return trxs[v.id].id ? trxs[v.id].id === v.id : false
                      }
                      return false
                    })
                    return m ? m.entities[v.t][v.id] : v
                  })
                  return this.$store.dispatch('updateTransactionSelection', group)
                })
                .catch(e => console.log(e))
            } else {
              this.$store.dispatch('updateTransactionSelection', group)
            }

            this.form[fieldName] = choices
          }
        }

        const data = Object.assign({}, this.form)

        if (this.endpoint === 'ledger/detail' && !data.base_currency && this.checkBankCurrencies() && !this.currencyWarningShown) {
          this.showCurrencyWarning()
          return
        }
        if (['posting/transaction', 'posting/account'].includes(this.endpoint) || ['audit/transaction', 'audit/account'].includes(this.endpoint)) {
          let reportURL = ''
          if (['posting/transaction'].includes(this.endpoint)) reportURL = 'djangoreports/report/posting-report-transaction/render/'
          else if (['posting/account'].includes(this.endpoint)) reportURL = 'djangoreports/report/posting-report-account/render/'
          else if (['audit/transaction'].includes(this.endpoint)) reportURL = 'djangoreports/report/audit-report-transaction/render/'
          else if (['audit/account'].includes(this.endpoint)) reportURL = 'djangoreports/report/audit-report-account/render/'
          let payload = {}
          if (this.endpoint === 'posting/transaction' || this.endpoint === 'audit/transaction') {
            Object.keys(data).forEach(k => {
              payload[k + '_ids'] = data[k]
            })
          } else {
            let keyMapping = {base_currency: 'base_currency_id', transaction__effective_date__lte: 'effective_date_end', transaction__effective_date__gte: 'effective_date_start', transaction__ledger__id__in: 'ledger_ids', transaction__time_posted__date__lte: 'posted_date_end', transaction__time_posted__date__gte: 'posted_date_start'}
            Object.keys(data).forEach(k => {
              payload[keyMapping[k]] = data[k]
            })
          }
          return this.fetchPythonReportData(reportURL, payload)
        }

        if (['audit/transaction', 'audit/account'].includes(this.endpoint)) {
          this.$store.dispatch('setPostBtnVisible', false)
        }
        this.closeViewer(true)
        this.$store.dispatch('cacheParams', { data })
          .then(r => {
            if (!(r && r.id)) return Promise.reject('No response')
            const { reportId } = r
            let query = { cached_parameters: r.id }
            const templateParameterKey = this.reportOptions(`reports/${this.endpoint}`).template_parameter
            if (templateParameterKey) {
              query[templateParameterKey] = this.template.toLowerCase()
            }
            const payload = { query, type: this.endpoint, reportId }
            return this.$store.dispatch('startRenderingReport', payload)
          })
          .catch(e => {
            console.log(e)
            notify(this, 'error', 'Error generating posting report')
          })
      },
      async updateSelectedTransactions () {
        let trns = []
        let ledgers = this.form.transaction__ledger__id__in
        for (let f in ledgers) {
          const ledgerId = ledgers[f]
          let trn = ''
          const resp = await this.getLedgerDataById(ledgerId)
          if (!resp.ledger) {
            resp.ledger = resp.id
          }
          resp.id = resp.transaction
          trn = resp
          if (resp.production) {
            trn.production = resp.production
          }
          if (resp.company) {
            trn.company = resp.company
          }
          if (resp.bank) {
            trn.bank = resp.bank
          }
          if (resp.type) {
            trn.transactionType = resp.type
          }
          trns.push(trn)
        }
        this.$store.dispatch('updateTransactionSelection', trns)
      },
      /**
       * Closes the report modal
       */
      closeViewer (visibleState) {
        if (!visibleState) {
          this.$store.dispatch('changeModalVisibility', null)
          this.endpoint = null
          this.$store.dispatch('updateTransactionSelection', [])
        } else {
          this.$store.dispatch('changeModalVisibility', { entityType: this.endpoint, visible: visibleState })
        }
        this.resetForm()
      },
      /**
       * Resets the form
       */
      resetForm () {
        for (let field in this.form) {
          let ref = this.$refs[field]
          if (!this.fields[field]) continue
          if (ref && ref[0] && this.fields[field].choices && this.fields[field].choices.length) {
            ref = ref[0]
            if (ref.isSelect && !ref.multiple && ref.selected) {
              this.$refs[field][0].selected = {}
            } else if (ref.isSelect && ref.multiple && ref.selected) {
              this.$refs[field][0].selected = []
            } else if (ref.leftChecked && ref.leftChecked.length) {
              this.$refs[field][0].leftChecked = []
              this.$refs[field][0].rightChecked = []
            }
          }
        }
        this.form = Object.assign({})
        this.template = null
        this.requirementsMet = false
        this.visibleOptionalField = null
        this.currencyWarning = null
        this.currencyWarningShown = false
        this.loading = false
        this.loaded = false
        this.preInitializeFields()
        this.initializeFields()
      },
      /**
       * Loads choices into el-transfer fields
       */
      transferElData (choices) {
        let data = []
        choices.forEach((val, index) => data.push({ label: val.display_name, key: index, value: val.value }))
        return data
      },
      /**
       * Filter method for Element-UI el-transfer fields
       */
      filterMethod (query, item) {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
      },
      /**
       * Check whether form requirements have been satisfied
       * TODO: this can be a computed property instead
       */
      checkRequirements () {
        const { form, fields } = this
        if (Object.keys(form).length) {
          let test = true
          for (let f in fields) {
            if (fields[f].required && (!form[f] || (Array.isArray(form[f]) && !form[f].length))) {
              test = false
            }
          }
          this.requirementsMet = test
        } else {
          this.requirementsMet = false
        }
      },
      /**
       * Handle el-transfer field change
       */
      handleChange () {
        const { form } = this
        let group = []
        let missing = {}
        for (let f in form) {
          let subgroup
          switch (f) {
            case 'accountspayable':
              subgroup = form[f].map(v => {
                let m = this.getApById(v)
                if (!Object.keys(m).length) m = { id: v, t: 'aps', missing: true }
                return m
              })
              break
            case 'journalentry':
              subgroup = form[f].map(v => {
                let m = this.getJeById(v)
                if (!Object.keys(m).length) m = { id: v, t: 'jes', missing: true }
                return m
              })
              break
            case 'payroll':
              subgroup = form[f].map(v => {
                let m = this.getJeById(v)
                if (!Object.keys(m).length) m = { id: v, t: 'jes', missing: true }
                return m
              })
              break
            case 'pettycash':
              subgroup = form[f].map(v => {
                let m = this.getPcById(v)
                if (!Object.keys(m).length) m = { id: v, t: 'pcs', missing: true }
                return m
              })
              break
            case 'accountsreceivable':
              subgroup = form[f].map(v => {
                let m = this.getArById(v)
                if (!Object.keys(m).length) m = { id: v, t: 'ars', missing: true }
                return m
              })
              break
          }
          if (subgroup) group.push(...subgroup)
        }
        for (let i = 0; i < group.length; i++) {    // Figure out which transactions are missing
          if (group[i].hasOwnProperty('missing')) {
            let { t } = group[i]
            if (missing.hasOwnProperty(t) && Array.isArray(missing[t])) {
              missing[t].push(group[i].id)
            } else {
              missing[t] = [group[i].id]
            }
          }
        }
        if (Object.keys(missing).length) {          // Fetch the missing transactions, if any
          let promises = buildInitPromiseIterable(this.$store, missing)
          Promise.all(promises)
            .then(r => {
              group = group.map(v => {              // TODO: refactor O(n^2) ugliness
                if (!v.hasOwnProperty('t')) return v
                let m = r.find(x => {
                  const trxs = x.entities && x.entities[v.t] ? x.entities[v.t] : null
                  if (v.id && trxs && trxs[v.id]) {
                    return trxs[v.id].id ? trxs[v.id].id === v.id : false
                  }
                  return false
                })
                return m ? m.entities[v.t][v.id] : v
              })
              return this.$store.dispatch('updateTransactionSelection', group)
            })
            .catch(e => console.log(e))
        } else {
          this.$store.dispatch('updateTransactionSelection', group)
        }
      },
      /**
       * Sorts and formats the report option fields
       */
      selectFields () {
        let { fields } = this
        let formatted = {}
        Object.keys(fields).filter(v => fields[v] ? !fields[v].many : false).forEach(f => {
          let field = fields[f]
          field['form_name'] = f
          if (field.name.includes('Date') || field.name === 'Period') {
            if (!formatted['timeframe']) formatted['timeframe'] = []
            formatted.timeframe.push(field)
          } else if (field.name === 'FF1' || field.name === 'FF2') {
            if (!formatted['freefields']) formatted['freefields'] = []
            formatted.freefields.push(field)
          } else if (field.name === 'Company' || field.name === 'Production') {
            if (!formatted['company_production']) formatted['company_production'] = []
            formatted.company_production.push(field)
          } else {
            if (!formatted['other']) formatted['other'] = []
            formatted.other.push(field)
          }
        })
        for (let f in formatted) {
          if (f === 'timeframe') { // Show 'Start' -> 'End' -> 'Period'
            formatted[f] = formatted[f].sort((a, b) => {
              if (a.name.includes('Start')) {
                return 0
              } else if (b.name.includes('End')) {
                return 1
              } else {
                return 2
              }
            })
          }
          if (f === 'freefields') {
            formatted[f] = formatted[f].sort((a, b) => a.name[a.name.length - 1] > b.name[b.name.length - 1])
          }
        }
        return formatted
      },
      /**
       * Initializes report form fields with default values
       */
      initializeFields () {
        if (this.templates && Object.keys(this.templates).length) {                     // Set default value for 'template' if more than one
          this.template = capitalizeFirstLetter(Object.keys(this.templates)[0])
        }
        if (this.requiredFields && this.requiredFields.length) {                        // Set default values for required fields
          this.requiredFields.forEach(field => {
            const defaultValue = this.$store.getters[`getDefault${field.name}`]
            if (defaultValue && defaultValue.id && field.choices.find(c => c.value === defaultValue.id).value) {
              const defaultChoice = field.choices.find(c => c.value === defaultValue.id).value
              let tmpForm = Object.assign({}, this.form)
              tmpForm[field.fieldName] = field.many ? [defaultChoice] : defaultChoice
              this.form = Object.assign({}, tmpForm)
            }
          })
        }
        if (this.optionalFieldsOfTypeMany && this.optionalFieldsOfTypeMany.length) {    // Set initially visible optional field
          this.visibleOptionalField = this.optionalFieldsOfTypeMany[0].name || null
          this.optionalFieldsOfTypeMany.forEach(field => {                              // Set pre-selected values for optional el-transfer fields
            if (field.fieldName === 'customer__in') {
              let tmpForm = Object.assign({}, this.form)
              tmpForm[field.fieldName] = field.choices.map(choice => choice.value)
              this.form = Object.assign({}, tmpForm)
            }
          })
        }
        if (this.endpoint === 'audit/transaction' || this.endpoint === 'posting/transaction') {
          this.getTransactions()
        }
      },
      /**
       * Since this is a dynamic form, we need to initialize this.form with pre-set properties in order for
       * v-model to work on element-ui select fields where 'multiple' is true.
       */
      preInitializeFields () {
        let tmp = Object.assign({}, this.form)
        switch (this.endpoint) {
          case 'ledger/detail':
            tmp.account__in = []
            tmp.transaction__batch__bank__in = []
            tmp.transaction__batch__company__in = []
            tmp.transaction__batch__production__in = []
            break
          case 'posting/account':
          case 'audit/account':
            tmp.transaction__ledger__id__in = []
        }
        this.form = Object.assign({}, tmp)
      },
      async getTransactions () {
        if (!this.aps.length && !this.jes.length && !this.pcs.length) {
          this.trnLoading = true
          this.getApTransactions()
          this.getJeTransactions()
          this.getPcTransactions()
        } else {
          this.trnLoading = false
        }
      },
      async getApTransactions () {
        let pageSize = 200
        const query = { page: 1, page_size: pageSize }
        const aps = await this.$store.dispatch('fetchApsWithQuery', { query })
        // Get additonal pages, if necessary
        if (aps && aps.count > pageSize) {
          query.page = 2
          let pageRequests = []
          const pagesNeeded = Math.ceil(aps.count / pageSize)
          while (query.page <= pagesNeeded) {
            pageRequests.push(this.$store.dispatch('fetchApsWithQuery', {
              query
            }))
            query.page++
          }
          await Promise.all(pageRequests)
          this.trnLoading = false
        } else {
          this.trnLoading = false
        }
      },
      async getJeTransactions () {
        let pageSize = 200
        const query = { page: 1, page_size: pageSize }
        const jes = await this.$store.dispatch('fetchJesWithQuery', { query })
        // Get additonal pages, if necessary
        if (jes && jes.count > pageSize) {
          query.page = 2
          let pageRequests = []
          const pagesNeeded = Math.ceil(jes.count / pageSize)
          while (query.page <= pagesNeeded) {
            pageRequests.push(this.$store.dispatch('fetchJesWithQuery', {
              query
            }))
            query.page++
          }
          await Promise.all(pageRequests)
        }
      },
      async getPcTransactions () {
        let pageSize = 200
        const query = { page: 1, page_size: pageSize }
        const pcs = await this.$store.dispatch('fetchPcsWithQuery', { query })
        // Get additonal pages, if necessary
        if (pcs && pcs.count > pageSize) {
          query.page = 2
          let pageRequests = []
          const pagesNeeded = Math.ceil(pcs.count / pageSize)
          while (query.page <= pagesNeeded) {
            pageRequests.push(this.$store.dispatch('fetchPcsWithQuery', {
              query
            }))
            query.page++
          }
          await Promise.all(pageRequests)
        }
      },
      /**
       * Returns the choices for option fields of type "many"
       * @return Array
       */
      getOptionalFieldChoices () {
        const field = this.optionalFieldsOfTypeMany.find(field => field.fieldName === this.visibleOptionalFieldName)
        if (field && field.choices) {
          if (this.endpoint === 'audit/transaction' || this.endpoint === 'posting/transaction') {
            let choices = field.choices.map(choice => choice.value)
            let filteredChoices = []
            const { form } = this

            let company = []
            let production = []
            let bank = []
            if (typeof form.company !== 'object') {
              company.push(form.company)
            } else {
              company = form.company
            }
            if (typeof form.production !== 'object') {
              production.push(form.production)
            } else {
              production = form.production
            }
            if (typeof form.bank !== 'object') {
              bank.push(form.bank)
            } else {
              bank = form.bank
            }

            switch (this.visibleOptionalFieldName) {
              case 'accountspayable':
                for (let f in choices) {
                  let res = this.getApById(choices[f])
                  if (res && res.id) {
                    if (company.length && production.length && bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (production.includes(res.batch_data.production)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (company.length && production.length && !bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (production.includes(res.batch_data.production))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (company.length && !production.length && bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (!company.length && production.length && bank.length) {
                      if (
                        (production.includes(res.batch_data.production)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    }
                  }
                }
                break
              case 'journalentry':
                for (let f in choices) {
                  let res = this.getJeById(choices[f])
                  if (res && res.id) {
                    if (company.length && production.length && bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (production.includes(res.batch_data.production)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (company.length && production.length && !bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (production.includes(res.batch_data.production))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (company.length && !production.length && bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (!company.length && production.length && bank.length) {
                      if (
                        (production.includes(res.batch_data.production)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    }
                  }
                }
                break
              case 'payroll':
                for (let f in choices) {
                  let res = this.getJeById(choices[f])
                  if (res && res.id) {
                    if (company.length && production.length && bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (production.includes(res.batch_data.production)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (company.length && production.length && !bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (production.includes(res.batch_data.production))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (company.length && !production.length && bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (!company.length && production.length && bank.length) {
                      if (
                        (production.includes(res.batch_data.production)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    }
                  }
                }
                break
              case 'pettycash':
                for (let f in choices) {
                  let res = this.getPcById(choices[f])
                  if (res && res.id) {
                    if (company.length && production.length && bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (production.includes(res.batch_data.production)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (company.length && production.length && !bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (production.includes(res.batch_data.production))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (company.length && !production.length && bank.length) {
                      if (
                        (company.includes(res.batch_data.company)) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    } else if (!company.length && production.length && bank.length) {
                      if (
                        (res.batch_data.production === form.production) &&
                        (bank.includes(res.batch_data.bank))
                      ) {
                        filteredChoices.push(field.choices.filter(choice => Number(choice.value) === Number(res.id))[0])
                      }
                    }
                  }
                }
                break
              default:
                filteredChoices = field.choices
                break
            }
            return filteredChoices
          } else {
            return field.choices
          }
        }
        return []
      },
      /**
       * Adds the 'fieldName' property to a field object, which contains the value of its key in 'fields'. This
       * value is used to set a property in this.form which corresponds to this field. Also, applies the provided
       * filter function and returns its result.
       * @param fields
       * @param filterFunc
       */
      formatAndFilterFields (fields, filterFunc) {
        if (fields && Object.values(fields).length) {
          fields = Object.values(fields).map((field, i) => {
            field['fieldName'] = Object.keys(fields)[i]
            return field
          })
          return fields.filter(filterFunc)
        }
        return []
      }
    },
    computed: {
      ...mapGetters({
        reportOptions: 'getReportOptions',
        fieldsTypeMany: 'getFormFieldsOfTypeMany',
        lastUpdated: 'getLastUpdated',
        getJeById: 'getJeById',
        getApById: 'getApById',
        getPcById: 'getPcById',
        getPoById: 'getPoById',
        getArById: 'getArById',
        getBankById: 'getBankById',
        aps: 'getAps',
        jes: 'getJes',
        pcs: 'getPcs'
      }),
      /**
       * Returns all fields resulting from an OPTIONS call to `reports/${this.endpoint}`
       */
      fields () {
        return this.$store.getters.getReportFormFields(`reports/${this.endpoint}`)
      },
      /**
       * Returns all required fields of type "many"
       * @return Array
       */
      requiredFieldsOfTypeMany () {
        let fields = this.$store.getters.getFormFieldsOfTypeMany(`reports/${this.endpoint}`)
        const filterFunc = (field) => field.required && (field.fieldName !== 'account__in')
        return this.formatAndFilterFields(fields, filterFunc)
      },
      /**
       * Returns required 'account_in' field of type "many"
       */
      requiredAccountFieldOfTypeMany () {
        let fields = this.$store.getters.getFormFieldsOfTypeMany(`reports/${this.endpoint}`)
        const filterFunc = (field) => field.required && (field.fieldName === 'account__in')
        return this.formatAndFilterFields(fields, filterFunc)
      },
      /**
       * Returns all required fields not of type "many" and of type "select"
       * @return Array
       */
      requiredSelectFields () {
        let fields = this.$store.getters.getReportFormFields(`reports/${this.endpoint}`)
        const filterFunc = (field) => !field.many && field.required && (field.choices && field.choices.length)
        return this.formatAndFilterFields(fields, filterFunc)
      },
      /**
       * Returns all required fields not of type "many" and of type "select"
       * @return Array
       */
      requiredTextInputFields () {
        let fields = this.$store.getters.getReportFormFields(`reports/${this.endpoint}`)
        const filterFunc = (field) => !field.many && field.required && !(field.choices && field.choices.length)
        return this.formatAndFilterFields(fields, filterFunc)
      },
      /**
       * Returns all optional fields of type "many"
       * @return Array
       */
      optionalFieldsOfTypeMany () {
        let fields = this.$store.getters.getFormFieldsOfTypeMany(`reports/${this.endpoint}`)

        if (this.endpoint === 'audit/transaction' || this.endpoint === 'posting/transaction') {
          let prs = fields.journalentry.choices.filter((c) => c.source_code === 5)
          fields.payroll.choices = [...fields.payroll.choices, ...prs]
          fields.journalentry.choices = fields.journalentry.choices.filter((c) => c.source_code !== 5)
        }
        const filterFunc = (field) => !field.required
        return this.formatAndFilterFields(fields, filterFunc)
      },
      /**
       * Returns all optional fields not of type "many" and of type "select"
       * @return Array
       */
      optionalSelectFields () {
        let fields = this.$store.getters.getReportFormFields(`reports/${this.endpoint}`)
        const filterFunc = (field) => !field.many && !field.required && (field.choices && field.choices.length)
        return this.formatAndFilterFields(fields, filterFunc)
      },
      /**
       * Returns all optional fields not of type "many" and of type "select"
       * @return Array
       */
      optionalTextInputFields () {
        let fields = this.$store.getters.getReportFormFields(`reports/${this.endpoint}`)
        const filterFunc = (field) => !field.many && !field.required && !(field.choices && field.choices.length)
        return this.formatAndFilterFields(fields, filterFunc)
      },
      /**
       * Returns all optional fields not of type "many"
       * @return Array
       */
      requiredFields () {
        let fields = this.$store.getters.getReportFormFields(`reports/${this.endpoint}`)
        const filterFunc = (field) => field.required
        return this.formatAndFilterFields(fields, filterFunc)
      },
      /**
       * Returns all optional fields not of type "many"
       * @return Array
       */
      optionalFields () {
        let fields = this.$store.getters.getReportFormFields(`reports/${this.endpoint}`)
        const filterFunc = (field) => !field.required
        return this.formatAndFilterFields(fields, filterFunc)
      },
      /**
       * Returns the field name of the currently visible el-transfer field
       */
      visibleOptionalFieldName () {
        if (this.optionalFieldsOfTypeMany && this.optionalFieldsOfTypeMany.length && this.visibleOptionalField) {
          const field = this.optionalFieldsOfTypeMany.find(field => field.name === this.visibleOptionalField)
          return field && field.fieldName ? field.fieldName : ''
        }
        return ''
      },
      /**
       * Returns whether a report modal is currently visible
       */
      visible () {
        const visible = this.$store.getters.getModalVisibilityState
        return Object.keys(visible).some(v => {
          if (this.availableEndpoints.includes(v)) {
            this.endpoint = v
            return true
          }
          return false
        })
      },
      /**
       * Returns the name of the report type, based on the report's endpoint
       * @return {*}
       */
      name () {
        switch (this.endpoint) {
          case 'audit/transaction':
            return 'Audit Report By Transaction'
          case 'audit/account':
            return 'Audit Report By Account'
          case 'ledger/detail':
            return 'GL Detail Report'
          case 'ledger/summary':
            return 'GL Summary Report'
          case 'posting/transaction':
            return 'Posting Report By Transaction'
          case 'posting/account':
            return 'Posting Report By Account'
          // case 'receivables/detail':
          //   return 'Accounts Receivable Detail Report'
          // case 'receivables/summary':
          //   return 'Accounts Receivable Summary Report'
          default:
            return 'Report'
        }
      },
      /**
       * Returns the template values available for this report type
       */
      templates () {
        const reportOpts = this.$store.getters.getReportOptions(`reports/${this.endpoint}`)
        return reportOpts && reportOpts.templates ? reportOpts.templates : {}
      }
    },
    watch: {
      /**
       * Watches the current endpoint. If an endpoint exists (meaning if the report dialog is showing), will check
       * when the field and parameter data for said endpoint was last updated. If this is the first time this
       * report has been run since app load, then shouldUpdate will be true and the fields and parameters for this
       * report type will be fetched from the API. If not, shouldUpdate will be true depending on whether or not
       * 10 minutes have elapsed since the last time the fields and parameters for this endpoint were last updated.
       */
      endpoint () {
        if (this.endpoint) {
          const { lastUpdated } = this
          this.preInitializeFields()
          const endpoint = `reports/${this.endpoint}`
          let lastUpdate = lastUpdated && lastUpdated[endpoint] ? lastUpdated[endpoint] : null    // Determine time of last update
          const shouldUpdate = (Math.round((new Date()).getTime() / 1000) - lastUpdate) > 600     // Determine if update is necessary (600s = 10m)
          if (shouldUpdate) {
            this.loading = true
            this.$store.dispatch('fetchFormFields', endpoint)
              .then(r => {
                if (!(r && Object.keys(r).length)) return Promise.reject()
                this.initializeFields()
                this.loaded = true
                this.loading = false
              })
              .catch(e => {
                this.loading = false
                notify(this, 'error', 'Error getting required report options')
                console.log(e)
              })
          } else {
            this.initializeFields()
          }
        } else {
          console.log('Report Builder closed.')
        }
      }
    },
    updated () {
      this.checkRequirements()
    },
    async mounted () {}
  }
</script>

<style>
  .select-field-label {
    text-align: end;
  }
  .field-section-header {
    font-weight: bold;
    margin: 12px 0;
  }
  .field-row {
    margin-bottom: 12px;
  }
  .input-container {
    margin: 0 6px;
  }
  #gl-dialog .el-dialog__header {
    padding: 0;
  }
  #gl-dialog .el-dialog--large {
    top: 8% !important;
  }
  .filter-name-container {
    padding-right: 10%;
  }
  .filter-name {
    font-weight: bold;
    margin: 12px 0;
    border-bottom: 1px solid lightgrey;
  }
  .transfer-filters {
    width: 100%;
  }
  .transfer-filters .el-transfer-panel {
    width: 40%;
  }
  .opts-col-name {
    padding: 3px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Reports/Report.vue